/* eslint-disable no-template-curly-in-string */
declare global {
  interface Window {
    ENV: any;
  }
}

export const API_URL = `${import.meta.env.VITE_API_HOST || '/api/v1'}`;

// export const GOOGLE_MAPS_API_KEY =
//   window.ENV.GOOGLE_MAPS_API_KEY === '${GOOGLE_MAPS_API_KEY}'
//     ? import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY
//     : window.ENV.GOOGLE_MAPS_API_KEY;

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY;

export const UAEPASS_DISABLE = '';
